import React from 'react'
import AddNewPatientFromApt from './AddNewPatientFromApt'
import { useDispatch } from 'react-redux'
import { toggleChildPopup } from '../../../../Redux/popups/popupSlice'

const index = ({ nested }) => {
  const { pointer, data } = nested

  const close = () => {
    dispatch(
      toggleChildPopup({
        pointer: 0,
        data: null
      })
    )
  }
  const dispatch = useDispatch()
  switch (pointer) {
    case 1: {
      const { category, opId, setSelectedPatient } = data
      return <AddNewPatientFromApt close={close} opId={opId} category={category} setSelectedPatient={setSelectedPatient} />
    }
    default: {
      close()
      break
    }
  }
}

export default index
